import { io } from 'socket.io-client';
import { isDev } from './query';

let socket = io(isDev() ? 'http://localhost:5000/' : '', {
    path: '/api/socket.io',
    autoConnect: false,
    auth: { token: localStorage.getItem('token'), room_token: undefined }
});
export default socket;
